var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#f7b64c"
    },
    points: "341.612,36.512 431.288,36.512 431.288,504.257 80.711,504.257 80.711,36.512 169.74,36.512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "338.297,73.281 392.322,73.281 392.322,464.427 119.678,464.427 119.678,73.281 173.702,73.281 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.788,
    y: 135.082,
    style: {
      fill: "#ffd15c"
    },
    width: 142.277,
    height: 34.405
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.788,
    y: 210.344,
    style: {
      fill: "#ffd15c"
    },
    width: 142.277,
    height: 34.405
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.461,
    y: 285.597,
    style: {
      fill: "#ffd15c"
    },
    width: 142.277,
    height: 34.405
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.461,
    y: 367.218,
    style: {
      fill: "#ffd15c"
    },
    width: 142.277,
    height: 34.405
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c0e99"
    },
    d: "M329.609,91.584H182.39c-4.798,0-8.688-3.89-8.688-8.688V16.43c0-4.798,3.89-8.688,8.688-8.688 h147.219c4.798,0,8.688,3.89,8.688,8.688v20.083v46.384C338.297,87.694,334.407,91.584,329.609,91.584z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffd15c"
    },
    points: "341.612,484.453 431.288,484.453 431.288,504.257 80.711,504.257 80.711,484.453 169.74,484.453 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c0e99"
    },
    d: "M173.702,48.186v34.71c0,4.798,3.89,8.688,8.688,8.688h147.218c4.798,0,8.688-3.89,8.688-8.688 v-34.71H173.702z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.288,28.77h-85.25V7.742c0-4.276-3.465-7.742-7.742-7.742H173.702c-4.277,0-7.742,3.466-7.742,7.742V28.77H80.712 c-4.277,0-7.742,3.466-7.742,7.742v467.746c0,4.276,3.465,7.742,7.742,7.742h350.577c4.277,0,7.742-3.466,7.742-7.742V36.512 C439.03,32.237,435.564,28.77,431.288,28.77z M173.702,99.326h164.595c4.277,0,7.742-3.466,7.742-7.742V72.902h38.542v383.784 H127.42V72.902h38.541v18.682C165.96,95.859,169.426,99.326,173.702,99.326z M181.444,15.484h149.111v68.358H181.444V15.484z M423.546,496.516H88.454V44.254h77.507v13.163h-46.283c-4.277,0-7.742,3.466-7.742,7.742v399.268c0,4.276,3.465,7.742,7.742,7.742 h272.645c4.277,0,7.742-3.466,7.742-7.742V65.16c0-4.276-3.465-7.742-7.742-7.742h-46.284V44.254h77.508L423.546,496.516 L423.546,496.516z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.788,177.23h142.277c4.277,0,7.742-3.466,7.742-7.742v-34.406c0-4.276-3.465-7.742-7.742-7.742H210.788 c-4.277,0-7.742,3.466-7.742,7.742v34.406C203.046,173.764,206.513,177.23,210.788,177.23z M218.53,142.824h126.793v18.922H218.53 V142.824z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.788,252.489h142.277c4.277,0,7.742-3.466,7.742-7.742v-34.407c0-4.276-3.465-7.742-7.742-7.742H210.788 c-4.277,0-7.742,3.466-7.742,7.742v34.407C203.046,249.022,206.513,252.489,210.788,252.489z M218.53,218.082h126.793v18.923H218.53 V218.082z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.735,277.856H212.459c-4.277,0-7.742,3.466-7.742,7.742v34.407c0,4.276,3.465,7.742,7.742,7.742h142.276 c4.277,0,7.742-3.466,7.742-7.742v-34.407C362.477,281.322,359.01,277.856,354.735,277.856z M346.993,312.262H220.201v-18.923 h126.792V312.262z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M354.735,359.473H212.459c-4.277,0-7.742,3.466-7.742,7.742v34.407c0,4.276,3.465,7.742,7.742,7.742h142.276 c4.277,0,7.742-3.466,7.742-7.742v-34.407C362.477,362.939,359.01,359.473,354.735,359.473z M346.993,393.879H220.201v-18.923 h126.792V393.879z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.63,140.353c-3.025-3.023-7.926-3.023-10.949,0s-3.023,7.926,0,10.948l14.652,14.652 c1.512,1.512,3.493,2.268,5.475,2.268c1.981,0,3.963-0.756,5.475-2.268l25.398-25.397c3.023-3.023,3.023-7.926,0-10.948 c-3.024-3.023-7.925-3.023-10.949,0l-19.923,19.923L150.63,140.353z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.731,204.865l-19.923,19.923l-9.178-9.178c-3.025-3.023-7.927-3.025-10.948,0c-3.025,3.023-3.025,7.925-0.001,10.948 l14.652,14.653c1.452,1.452,3.421,2.268,5.475,2.268s4.022-0.815,5.475-2.268l25.398-25.398c3.023-3.024,3.023-7.926,0-10.948 C187.655,201.843,182.754,201.843,179.731,204.865z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.731,280.421l-19.923,19.923l-9.178-9.178c-3.025-3.023-7.927-3.025-10.948,0c-3.025,3.023-3.025,7.925-0.001,10.948 l14.652,14.653c1.452,1.452,3.421,2.268,5.475,2.268s4.022-0.815,5.475-2.268l25.398-25.398c3.023-3.023,3.023-7.926,0-10.948 C187.655,277.398,182.754,277.398,179.731,280.421z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.731,366.245l-19.923,19.923l-9.178-9.178c-3.025-3.023-7.927-3.023-10.948,0c-3.025,3.023-3.025,7.925-0.001,10.948 l14.652,14.653c1.452,1.452,3.421,2.268,5.475,2.268s4.022-0.816,5.475-2.268l25.398-25.398c3.023-3.023,3.023-7.926,0-10.948 C187.655,363.222,182.754,363.222,179.731,366.245z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.334fdd37e1d14bf78e456751778e2f54.svg";
export { ForwardRef as ReactComponent };